module.exports = __webpack_public_path__ + "img/MGH-Gaien-3-2440x1172.d8632b98.jpg";